import { getActionTitleByWhenType } from '@/utils/common.util';

export default {
  data(): any {
    return {
      bookingActionWhenTypeItems: [
        {
          text: this.$tc(getActionTitleByWhenType('after_new_booking')),
          value: 'after_new_booking'
        },
        {
          text: this.$tc(getActionTitleByWhenType('if_booking_rescheduled')),
          value: 'if_booking_rescheduled'
        },
        {
          text: this.$tc(getActionTitleByWhenType('if_booking_cancelled')),
          value: 'if_booking_cancelled'
        },
        {
          text: this.$tc(getActionTitleByWhenType('reminders_before_the_booking')),
          value: 'reminders_before_the_booking'
        },
        {
          text: this.$tc(getActionTitleByWhenType('after_appointment_ends')),
          value: 'after_appointment_ends'
        }
      ],
      bookingActionSubTypeItems: [
        { text: this.$tc(getActionTitleByWhenType('by_me')), value: 'by_me' },
        { text: this.$tc(getActionTitleByWhenType('by_booker')), value: 'by_booker' }
      ],
      bookingActionTypeItems: [
        { text: this.$tc('email'), value: 'email' },
        { text: this.$tc('sms'), value: 'sms' }
        // { text: this.$tc('webhook'), value: 'webhook' }
      ],
      bookingActionAudienceItems: [
        { text: this.$tc('toMe'), value: 'me' },
        { text: this.$tc('toBooker'), value: 'booker' },
        {
          text: this.$tc('anyEmailOrMobile'),
          value: 'any_mobile_or_email'
        }
      ]
    };
  }
} as any;
